export function acknowledgeCookieBanner() {
  var date = new Date();
  date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
  var expires = 'expires=' + date.toUTCString();
  document.cookie = 'cookieBannerAcknowledged=true;' + expires + ';path=/';
  document.querySelectorAll('.cookie-banner').forEach((banner) => {
    banner.style.display = 'none';
  });
}

document.addEventListener('DOMContentLoaded', () => {
  var cookieBannerCookieName = 'cookieBannerAcknowledged';
  var cookies = document.cookie.split(';');
  for (var i = 0; i < cookies.length; i++) {
    var name = cookies[i].split('=')[0].toLowerCase().trim();
    var value = cookies[i].split('=')[1].toLowerCase().trim();
    if (name == cookieBannerCookieName.toLowerCase()) {
      document.querySelectorAll('.cookie-banner').forEach((banner) => {
        banner.classList.add('d-none');
      });
      return;
    }
  }
  document.querySelectorAll('.cookie-banner').forEach((banner) => {
    banner.classList.remove('d-none');
  });
});

export { acknowledgeCookieBanner as default };
